import {
    tss,
} from 'app/tss'

export default tss.create({
    containerWrapper: {
        height: '100%',
        alignItems: 'center',
        width: '100%',
        marginLeft: 'auto',
        boxSizing: 'border-box',
        marginRight: 'auto',
        display: 'block',
    },
    container: {
        height: 'inherit',
        alignContent: 'flex-start',
    },
})
